import { render, staticRenderFns } from "./DriverEditTabInformation.vue?vue&type=template&id=b10b0f28&"
import script from "./DriverEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./DriverEditTabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports